// extracted by mini-css-extract-plugin
export default {"container":"notecard-editor-select-font__container___iMZEP","item":"notecard-editor-select-font__item___n8WJr","itemSelected":"notecard-editor-select-font__itemSelected___byiTE"};